import { render, staticRenderFns } from "./orderedit.vue?vue&type=template&id=10cb91fe&scoped=true&"
import script from "./orderedit.vue?vue&type=script&lang=js&"
export * from "./orderedit.vue?vue&type=script&lang=js&"
import style0 from "./orderedit.vue?vue&type=style&index=0&id=10cb91fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb91fe",
  null
  
)

export default component.exports